import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useInput, useTranslate } from 'react-admin';

import { filterColors } from '../../utils/constants';
import { FilterToggleButtonGroup, StyledToggleButton } from './FilterToggleInput';

const useStyles = makeStyles({
	filterState: {
		backgroundColor: filterColors.state
	},
});


export const ToggleStatusEnum = {
	COMPLETED: "completed",
	NOT_COMPLETED: "notCompleted",
};


export const ToggleCompletedStatusFilter = (props) => {
	const translate = useTranslate();
	const classes = useStyles();
	const { input } = useInput(props);
	const value = input.value;

	const handleChange = (e, newValue) => {
		input.onChange(newValue);
	};

	return (
		<FilterToggleButtonGroup value={value} onChange={handleChange} label={input.label} exclusive className={classes.filterState}>
			<StyledToggleButton value={ToggleStatusEnum.COMPLETED}>
				{translate('osfc.filters.state.completed')}
			</StyledToggleButton>
			<StyledToggleButton value={ToggleStatusEnum.NOT_COMPLETED}>
				{translate('osfc.filters.state.not_completed')}
			</StyledToggleButton>
		</FilterToggleButtonGroup>
	);
};
